(function() {
  // Guard clause if ERP validation is disabled or not set up
  const config = window.PH?.erpValidation;
  if (!config || !config.enabled || !config.endpoint) {
    console.log("ERP Stock validation is disabled or endpoint is not configured.");
    return;
  }

  async function validateCartStock(items) {
    const response = await fetch(config.endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: items.map((item) => ({
          sku: item.sku,
          quantity: item.quantity,
        })),
      }),
    });
    if (!response.ok) {
      throw new Error("No se pudo validar el stock");
    }
    return response.json();
  }

  async function getCartItemsToValidate() {
    const cartForm = document.querySelector('form.ph-cart-form');
    if (cartForm) {
      const qtyInputs = cartForm.querySelectorAll('.ph-qty-input');
      if (qtyInputs.length > 0) {
        const items = [];
        qtyInputs.forEach(input => {
          const sku = input.getAttribute('data-sku');
          const quantity = parseInt(input.value, 10);
          if (sku && quantity > 0) {
            items.push({ sku, quantity });
          }
        });
        return items;
      }
    }

    const cart = await fetch("/cart.js").then((res) => res.json());
    return cart.items
      .filter((item) => item.sku)
      .map((item) => ({
        sku: item.sku,
        quantity: item.quantity,
      }));
  }

  function clearOldWarnings() {
    document.querySelectorAll('.ph-stock-warning-inline, .ph-stock-warning-banner').forEach(el => el.remove());
  }

  async function adjustItemQuantity(sku, lineIndex, newQty) {
    try {
      // Find all buttons that match "Ajustar cantidad" for this SKU and show loading
      document.querySelectorAll(`.ph-adjust-btn[data-sku="${sku}"]`).forEach(btn => {
        btn.disabled = true;
        btn.textContent = "Ajustando...";
      });

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: newQty })
      });

      // Dispatch global update to refresh drawer/count
      document.dispatchEvent(new CustomEvent('ph:cart:updated'));

      // If we are on the cart page, reload the page
      if (window.location.pathname.endsWith('/cart')) {
        window.location.reload();
      } else {
        // If drawer is open, wait a bit and re-trigger fetch/render to show updated quantities
        setTimeout(() => {
          clearOldWarnings();
          if (window.phOpenDrawer) window.phOpenDrawer('CartDrawer');
        }, 500);
      }
    } catch (e) {
      console.error("Error adjusting item quantity:", e);
      alert("No se pudo ajustar la cantidad. Por favor intenta de nuevo.");
    }
  }

  function showInlineError(item) {
    // Search for item elements by SKU in the DOM (Drawer or Cart Page)
    const targets = document.querySelectorAll(`[data-sku="${item.sku}"]`);
    let injected = false;

    targets.forEach(target => {
      let container = target;
      if (target.classList.contains('ph-qty-input')) {
        container = target.closest('.ph-cart-item');
      }

      if (container) {
        const warningDiv = document.createElement('div');
        warningDiv.className = 'ph-stock-warning-inline';
        warningDiv.style.marginTop = '0.5rem';
        warningDiv.style.padding = '0.5rem 0.75rem';
        warningDiv.style.backgroundColor = '#FFF5F5';
        warningDiv.style.borderLeft = '3px solid #BF0228';
        warningDiv.style.borderRadius = '4px';
        warningDiv.style.fontSize = '0.85rem';
        warningDiv.style.color = '#BF0228';
        warningDiv.style.display = 'flex';
        warningDiv.style.flexDirection = 'row';
        warningDiv.style.alignItems = 'center';
        warningDiv.style.justifyContent = 'space-between';
        warningDiv.style.gap = '0.5rem';
        warningDiv.style.fontFamily = 'sans-serif';
        warningDiv.style.gridColumn = '1 / -1'; // Grid span for layout styling if grid

        const isEs = document.documentElement.lang.startsWith('es') || window.location.pathname.includes('/es');
        const lineIndex = container.getAttribute('data-line-index') || '1';

        const textSpan = document.createElement('span');
        textSpan.style.lineHeight = '1.3';
        if (item.available > 0) {
          textSpan.innerHTML = isEs 
            ? `El stock real solo cuenta con <strong>${item.available}</strong> unidades disponibles.`
            : `Only <strong>${item.available}</strong> units available in stock.`;
        } else {
          textSpan.innerHTML = isEs
            ? `Este producto se encuentra <strong>agotado</strong>.`
            : `This product is <strong>out of stock</strong>.`;
        }

        warningDiv.appendChild(textSpan);

        if (item.available >= 0) {
          const adjustBtn = document.createElement('button');
          adjustBtn.type = 'button';
          adjustBtn.className = 'ph-adjust-btn';
          adjustBtn.setAttribute('data-sku', item.sku);
          adjustBtn.textContent = item.available > 0 
            ? (isEs ? `Comprar ${item.available}` : `Buy ${item.available}`)
            : (isEs ? `Quitar` : `Remove`);
          
          adjustBtn.style.background = '#BF0228';
          adjustBtn.style.color = '#fff';
          adjustBtn.style.border = 'none';
          adjustBtn.style.padding = '0.25rem 0.5rem';
          adjustBtn.style.fontSize = '0.75rem';
          adjustBtn.style.borderRadius = '3px';
          adjustBtn.style.cursor = 'pointer';
          adjustBtn.style.fontWeight = 'bold';
          adjustBtn.style.whiteSpace = 'nowrap';
          adjustBtn.style.transition = 'background 0.2s';
          
          adjustBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            adjustItemQuantity(item.sku, parseInt(lineIndex), item.available);
          });

          warningDiv.appendChild(adjustBtn);
        }

        // Find details element or append directly
        const details = container.querySelector('.ph-cart-item-details') || container.querySelector('.drawer-item-details');
        if (details) {
          details.appendChild(warningDiv);
        } else {
          container.appendChild(warningDiv);
        }
        injected = true;
      }
    });

    return injected;
  }

  function showBannerError(message) {
    const container = document.getElementById('CartDrawerFooter') || document.querySelector('.ph-cart-summary');
    if (container) {
      const banner = document.createElement('div');
      banner.className = 'ph-stock-warning-banner';
      banner.style.padding = '0.75rem';
      banner.style.backgroundColor = '#FFF5F5';
      banner.style.borderLeft = '4px solid #BF0228';
      banner.style.color = '#BF0228';
      banner.style.fontSize = '0.85rem';
      banner.style.marginBottom = '1rem';
      banner.style.borderRadius = '4px';
      banner.style.fontFamily = 'sans-serif';
      banner.style.lineHeight = '1.4';
      banner.innerHTML = message;
      
      container.insertBefore(banner, container.firstChild);
    } else {
      alert(message.replace(/<[^>]*>/g, ''));
    }
  }

  async function handleCheckoutAttempt(event, button) {
    event.preventDefault();
    event.stopPropagation();

    clearOldWarnings();

    // Disable button and show loading state
    const originalText = button.textContent || button.value;
    const isButton = button.tagName === 'BUTTON' || button.tagName === 'INPUT';
    
    if (isButton) {
      button.disabled = true;
      button.textContent = "Validando stock...";
    } else {
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.6';
      button.textContent = "Validando stock...";
    }

    try {
      const items = await getCartItemsToValidate();
      if (items.length === 0) {
        proceedToCheckout();
        return;
      }

      const result = await validateCartStock(items);
      if (!result.valid) {
        const isEs = document.documentElement.lang.startsWith('es') || window.location.pathname.includes('/es');
        let injectedAny = false;
        
        result.unavailable.forEach(item => {
          const success = showInlineError(item);
          if (success) injectedAny = true;
        });

        const generalMsg = isEs
          ? "<strong>Atención:</strong> Hay productos en tu carrito con stock insuficiente en nuestro almacén. Por favor, ajusta las cantidades a continuación."
          : "<strong>Notice:</strong> Some products in your cart have insufficient stock. Please adjust quantities below.";
        showBannerError(generalMsg);

        // Restore button state
        if (isButton) {
          button.disabled = false;
          button.textContent = originalText;
        } else {
          button.style.pointerEvents = 'auto';
          button.style.opacity = '1';
          button.textContent = originalText;
        }
      } else {
        proceedToCheckout();
      }
    } catch (error) {
      console.error("Error al validar el stock:", error);
      const isEs = document.documentElement.lang.startsWith('es') || window.location.pathname.includes('/es');
      alert(isEs 
        ? "Hubo un problema al validar el stock del carrito. Por favor, intenta de nuevo."
        : "There was a problem validating the cart stock. Please try again."
      );
      
      // Restore button state
      if (isButton) {
        button.disabled = false;
        button.textContent = originalText;
      } else {
        button.style.pointerEvents = 'auto';
        button.style.opacity = '1';
        button.textContent = originalText;
      }
    }
  }

  function proceedToCheckout() {
    window.location.href = "/checkout";
  }

  function initListeners() {
    const cartForm = document.querySelector('form.ph-cart-form');
    if (cartForm) {
      const checkoutBtn = cartForm.querySelector('[name="checkout"]');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function(e) {
          handleCheckoutAttempt(e, checkoutBtn);
        });
      }
    }

    document.addEventListener('click', function(e) {
      const drawerCheckoutBtn = e.target.closest('.drawer-checkout-btn');
      if (drawerCheckoutBtn) {
        handleCheckoutAttempt(e, drawerCheckoutBtn);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initListeners);
  } else {
    initListeners();
  }
})();
